import type { FC, PropsWithChildren } from "react";
import { cx } from "@stubhub/broadway-foundation/css";
import {
  EventGridListItemContent,
  EventGridListItemContentFieldType,
  eventGridListItemContentRecipe,
  EventGridListItemSubtitle,
  eventGridListItemTagsRecipe,
} from "@stubhub/ensemble-discovery";
import { mlbPlayoffSubtitleClasses, mlbPlayoffTagRow } from "./MlbPlayoffs.styles";

const { contentPart, onlyMobile, onlyTabletDesktop } = eventGridListItemContentRecipe({ loadingState: "idle" });
const { container: tagsContainer } = eventGridListItemTagsRecipe();

export const MlbPlayoffGameDetails: FC<{ label: string | null; timeLabel?: string | undefined }> = ({
  label,
  timeLabel,
}) => (
  <div>
    <div className={onlyTabletDesktop}>
      <EventGridListItemSubtitle classes={mlbPlayoffSubtitleClasses}>
        {label && <span className={contentPart}>{label}</span>}
        {timeLabel && <span className={contentPart}>{timeLabel}</span>}
        <EventGridListItemContent
          fields={[
            ...(timeLabel ? [] : [{ type: EventGridListItemContentFieldType.Time }]),
            { type: EventGridListItemContentFieldType.VenueLocation },
            { type: EventGridListItemContentFieldType.VenueName },
          ]}
        />
      </EventGridListItemSubtitle>
    </div>
    <div className={onlyMobile}>
      <EventGridListItemSubtitle classes={mlbPlayoffSubtitleClasses}>
        {timeLabel && <span className={contentPart}>{timeLabel}</span>}
        <EventGridListItemContent
          fields={[
            ...(timeLabel ? [] : [{ type: EventGridListItemContentFieldType.Time }]),
            { type: EventGridListItemContentFieldType.VenueLocation },
          ]}
        />
      </EventGridListItemSubtitle>
      <EventGridListItemSubtitle classes={mlbPlayoffSubtitleClasses}>
        {label && <span className={contentPart}>{label}</span>}
        <EventGridListItemContent fields={[{ type: EventGridListItemContentFieldType.VenueName }]} />
      </EventGridListItemSubtitle>
    </div>
  </div>
);

export const MlbPlayoffTagRow: FC<PropsWithChildren> = ({ children }) => (
  <div className={cx(tagsContainer, mlbPlayoffTagRow)}>{children}</div>
);
